import { EntityActionRevertedDetails } from '@evidentid/tprm-portal-lib/models/activity-history';

import { ACTION_TYPE_LABELS } from '@/modules/entity-events/utils/formatEntityActionResolvedSummary';

/**
 * Human-readable summary for an ENTITY_ACTION_REVERTED entry, e.g.
 * "Entity name matching action was reverted".
 *
 * Shares its labels with the resolved summary because both events carry the same `$action` token, and
 * degrades the same way: an action type this app does not recognise still reverted something, so it
 * reads "An action was reverted" rather than naming the event only.
 *
 * The reviewer's reason is deliberately not part of this sentence. It is a note, read through the
 * row's view action like every other note in this table, so the description stays one predictable
 * line whatever was typed.
 */
export function formatEntityActionRevertedSummary(
    details: EntityActionRevertedDetails | null | undefined,
): string {
    const actionLabel = details?.actionType ? ACTION_TYPE_LABELS[details.actionType] : undefined;
    return actionLabel ? `${actionLabel} action was reverted` : 'An action was reverted';
}
